import { createContext, useContext, useState, type ReactNode } from "react";

type UserBarData = {
  type: "hidden" | "main" | "parent"
} | {
  type: "patient"
  patientAvatarKey?: string
  patientFirstName?: string
  patientLastName?: string
  pediatricianAvatarKey?: string
  pediatricianFirstName?: string
  pediatricianLastName?: string
} | {
  type: "grow-together"
  patientAvatarKey?: string
  patientFirstName?: string
  patientLastName?: string
}

export interface UserBarContextType {
  userBarData: UserBarData;
  setUserBarData: (userBarData: UserBarData) => void;
}

export const UserBarContext = createContext<UserBarContextType | undefined>(undefined);

export const useUserBarContext = () => {
  const context = useContext(UserBarContext);
  if (context === undefined) { throw new Error("UserBarContext not found"); }
  return context;
};

export interface UserBarContextProviderProps {
  children: ReactNode;
}

export const UserBarContextProvider: React.FC<UserBarContextProviderProps> = (props) => {
  const { children } = props;

  const [userBarData, setUserBarData] = useState<UserBarData>({ type: "main" });

  const value: UserBarContextType = {
    userBarData,
    setUserBarData
  };

  return (
    <UserBarContext.Provider value={value}>
      {children}
    </UserBarContext.Provider>
  );
}